import { MatDialog } from '@angular/material/dialog';
import { Component } from '@angular/core';
import { SearchComponent } from './shared/components/search/search.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { cnpjValidator, emailValidator, phoneValidator } from './shared/utils/app-validators';
import { SwalService } from './shared/services/swal.service';
import { MetaService } from './shared/services/meta.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Blukit - O lado inteligente da hidráulica';
  collectiveVacation = '';
  showWhats = false;
  nameIsValid = false;
  formWhatsApp!: FormGroup;
  contato = '554733310800'
  submitted = false;
  cookiesAccepted = false;

  constructor(private matDialog : MatDialog, private fb: FormBuilder, private swalService: SwalService, private metaService: MetaService ) {
  }

  ngOnInit(){
    if (localStorage.getItem('cookiesAccepted')) {
      this.cookiesAccepted = true;
    }
    this.metaService.getCanonicalUrl().subscribe(canonicalUrl => {
      this.addCanonicalLink(canonicalUrl);
    });

    this.metaService.getDescription().subscribe(description => {
      description.then((res) => {
        this.updateMetaTag('description', res);
        this.updateTitle(res);
      })
    });

    this.metaService.getOgUrl().subscribe(ogUrl => {
      this.updateMetaTag('og:url', ogUrl);
    });

    this.formWhatsApp = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      email: [null, Validators.compose([Validators.required, emailValidator])],
      telefone: [null, Validators.compose([Validators.required, phoneValidator])],
      cnpj: [null, Validators.compose([Validators.required, cnpjValidator])]
    })
  }

  private addCanonicalLink(canonicalUrl: string) {
    const link: HTMLLinkElement = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
  }

  private updateMetaTag(property: string, content: string) {
    const tag = this.getOrCreateMetaTag(property);
    tag.setAttribute('content', content);
  }

  private getOrCreateMetaTag(property: string): HTMLMetaElement {
    const head = document.getElementsByTagName('head')[0];
    const tag = head.querySelector(`meta[name="${property}"]`);

    if (tag instanceof HTMLMetaElement) {
      return tag;
    } else {
      const newTag = document.createElement('meta');
      newTag.setAttribute('name', property);
      head.appendChild(newTag);
      return newTag;
    }

  }

  private updateTitle(title: string) {
    document.title = title; // Atualiza o título da página
  }
  openModalSearch(){
    const dialogRef = this.matDialog.open(SearchComponent, {
      width: '100%',
      height: '100%',
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  closeWhats(){
    this.showWhats = false;
  }
  openLgpd(){
    window.open('https://www.blukit.com.br/Politica-de-Privacidade-Blukit.pdf', 'target')
  }

  acceptCookies(){
    localStorage.setItem('cookiesAccepted', 'true');
    this.cookiesAccepted = true;
  }

  onSubmit(){
    this.submitted = true;
    if (!this.formWhatsApp.valid) {
      this.swalService.fireErrorSwal('Formulário não enviado','Existem campos obrigatórios não preenchidos.')
      return;
    }
    this.enviarMensagemWhats();


  }
  enviarMensagemWhats(){
    let urlApi = `https://wa.me/${this.contato}?`;

    let texto = `Olá. Gostaria de iniciar meu atendimento!%0ANome: ${ this.formWhatsApp.controls['nome'].value}%0ATelefone: ${ this.formWhatsApp.controls['telefone'].value}%0AEmail: ${ this.formWhatsApp.controls['email'].value}%0ACNPJ: ${ this.formWhatsApp.controls['cnpj'].value}`
    window.open(urlApi + "&text=" + texto, "_blank");
    this.showWhats = false;
  }
}
